import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, ClientOnly } from "@tanstack/react-router";

import { SiteFrame } from "@/session/site-frame";
import { publicConfig } from "@/lib/public-config";
import { ProductSession } from "@/session/product-session";
import { ProductNavigation } from "@/session/product-navigation";
import {
  ProductRouteError,
  ProductRoutePending,
} from "@/session/product-route-frame";
import { ProductRouteNotFound } from "../session/product-route-error";
import "@softmax/design-tokens/tokens.css";
import "@softmax/design-system/global.css";
import "@/styles/fonts.css";
import "@/styles/global.css";
import { Application } from "../session/product-application";
import { Document } from "../session/product-document";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  ssr: false,
  head: () => ({
    meta: [
      { charSet: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { name: "softmax-revision", content: publicConfig.revision },
      { title: "Softmax" },
      {
        name: "description",
        content: "Play, build, and explore coworlds on Softmax.",
      },
      { property: "og:type", content: "website" },
      { property: "og:title", content: "Softmax" },
      {
        property: "og:description",
        content: "Play, build, and explore coworlds on Softmax.",
      },
      { property: "og:image", content: "https://softmax.com/opengraph-image" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: "https://softmax.com/opengraph-image" },
    ],
  }),
  shellComponent: Document,
  component: () => (
    <ClientOnly fallback={<ProductRoutePending />}>
      <Application />
    </ClientOnly>
  ),
  errorComponent: ProductRouteError,
  notFoundComponent: () => (
    <ClientOnly fallback={<ProductRoutePending />}>
      <ProductNavigation>
        <ProductSession>
          <SiteFrame agent={false}>
            <ProductRouteNotFound />
          </SiteFrame>
        </ProductSession>
      </ProductNavigation>
    </ClientOnly>
  ),
});
